export default __webpack_public_path__ + "static/media/woocommerce-product-attribute.e62a5257.gif";